import { POI_DATA_MAP } from './poiDataMap'

// --- Primary metric configuration per building ---

export type MetricVisualType = 'battery' | 'thermometer' | 'gauge' | 'number'

export interface PrimaryMetricConfig {
  /** Which summary label to use as the metric */
  label: string
  /** Gauge minimum value */
  gaugeMin: number
  /** Gauge maximum value */
  gaugeMax: number
  /** Unit string displayed */
  gaugeUnit: string
  /** Visual indicator type */
  visualType: MetricVisualType
}

export const METRIC_CONFIGS: Record<string, PrimaryMetricConfig[]> = {
  'battery-cluster-1': [
    { label: 'Avg SOC', gaugeMin: 0, gaugeMax: 100, gaugeUnit: '%', visualType: 'battery' },
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'battery-cluster-2': [
    { label: 'Avg SOC', gaugeMin: 0, gaugeMax: 100, gaugeUnit: '%', visualType: 'battery' },
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'battery-cluster-3': [
    { label: 'Avg SOC', gaugeMin: 0, gaugeMax: 100, gaugeUnit: '%', visualType: 'battery' },
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'idt-1': [
    { label: 'Temp', gaugeMin: 0, gaugeMax: 120, gaugeUnit: 'C', visualType: 'thermometer' },
  ],
  'idt-2': [
    { label: 'Temp', gaugeMin: 0, gaugeMax: 120, gaugeUnit: 'C', visualType: 'thermometer' },
  ],
  'idt-3': [
    { label: 'Temp', gaugeMin: 0, gaugeMax: 120, gaugeUnit: 'C', visualType: 'thermometer' },
  ],
  'ecs-cluster-1': [
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'ecs-cluster-2': [
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'ecs-cluster-3': [
    { label: 'Power', gaugeMin: -500, gaugeMax: 500, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'control-centre': [
    { label: 'Power', gaugeMin: -1000, gaugeMax: 1000, gaugeUnit: 'kW', visualType: 'gauge' },
    { label: 'Schedule', gaugeMin: -1000, gaugeMax: 1000, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  'aux-cabinet': [
    { label: 'AUX Total', gaugeMin: 0, gaugeMax: 200, gaugeUnit: 'kW', visualType: 'gauge' },
  ],
  ems: [{ label: 'Power', gaugeMin: -1000, gaugeMax: 1000, gaugeUnit: 'kW', visualType: 'gauge' }],
}

// --- Default panel placement per building ---

export interface PanelDefaults {
  offset: [number, number, number]
  rotationY: number
  scale: number // uniform scale multiplier
  baseSize: [number, number] // base width, height in world units
}

/** Derive defaults from existing POI_DATA_MAP textOffset and textRotationY */
export const PANEL_DEFAULTS: Record<string, PanelDefaults> = Object.fromEntries(
  POI_DATA_MAP.map((config) => [
    config.poiId,
    {
      offset: config.textOffset,
      rotationY: config.textRotationY,
      scale: 1.0,
      baseSize: [3, 3] as [number, number],
    },
  ])
)

// --- Utility ---

/** Extract a numeric value from formatted strings like '45%', '120 kW', '65.2 C' */
export function parseMetricValue(raw: string): number {
  const match = raw.match(/-?[\d.]+/)
  return match ? parseFloat(match[0]) : 0
}
